import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './StudioPayment.css';

import { TopMenu } from '../../component/TopMenu';
import "../../styles/font.css";
import { API_CONFIG } from '../../config/api';

export const StudioPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('card');

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userName, setUserName] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');

  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  const gotoMain = () => {
    navigate('/');
  }
  const goToStudioTour = () => {
    navigate('/studio-tour');
  }
  const handleLogout = () => {
    // 일반 사용자 관련 모든 쿠키 삭제
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

    // 작가 관련 모든 쿠키 삭제
    document.cookie = "yournest_a_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_profile=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_company=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_description=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_type=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_address=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lat=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lng=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    
    setIsAuthenticated(false);
    setUserType(null);
    setUserName("");
    alert("로그아웃 되었습니다");
  };

  useEffect(() => {
    const userAuthToken = getCookie('yournest_u_auth_token');
    
    if (!userAuthToken) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    
    setIsAuthenticated(true);
    setUserType(userType);
  }, []);


  // state가 없는 경우(URL 직접 접근) 처리
  useEffect(() => {
    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const orderId = searchParams.get('orderId');
    const pgToken = searchParams.get('pg_token');
    
    // 결제 성공/취소/실패 URL인 경우
    if (path.includes('/success') || path.includes('/cancel') || path.includes('/fail')) {
      if (path.includes('/success') && orderId && pgToken) {
        updatePaymentStatus(orderId);
      } else if (path.includes('/cancel')) {
        alert('결제가 취소되었습니다.');
        navigate('/studio-tour');
      } else if (path.includes('/fail')) {
        alert('결제에 실패했습니다.');
        navigate('/studio-tour');
      }
    } 
    // 기본 결제 페이지인데 state가 없는 경우
    else if (!location.state) {
      alert('잘못된 접근입니다.');
      navigate('/studio-tour');
    }
  }, [location]);

  // state가 있는 경우에만 데이터 추출
  const { 
    tourId = '', 
    userId = '', 
    tourName = '', 
    reservationDate = null, 
    reservationTime = '', 
    amount = 0, 
    totalPrice = 0 
  } = location.state || {};

  // 결제 상태 업데이트 함수
  const updatePaymentStatus = async (orderId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/update_payment_status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: orderId,
          payment_status: 'completed'
        })
      });

      if (!response.ok) {
        throw new Error('결제 상태 업데이트 실패');
      }

      alert('결제가 완료되었습니다.');
      navigate('/customer-mypage');
    } catch (error) {
      console.error('결제 상태 업데이트 중 오류 발생:', error);
      alert('결제 처리 중 오류가 발생했습니다.');
      navigate('/studio-tour');
    }
  };

  const handlePayment = async () => {
    const userAuthToken = getCookie('yournest_u_auth_token');
    const userType = getCookie('yournest_u_type');
    
    if (!userAuthToken) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    
    try {
      // 1. 예약 생성
      const bookingResponse = await fetch(`${API_CONFIG.MAIN}/create_booking`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tour_id: tourId,
          user_id: userId,
          booking_date: reservationDate,
          booking_time: reservationTime,
          number_of_people: amount
        })
      });

      if (!bookingResponse.ok) {
        throw new Error('예약 생성 실패');
      }

      const bookingData = await bookingResponse.json();

      // 2. 주문 생성
      const orderResponse = await fetch(`${API_CONFIG.MAIN}/create_order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          booking_id: bookingData.bookingId,
          user_id: userId,
          payment_method: paymentMethod,
          payment_amount: totalPrice
        })
      });

      if (!orderResponse.ok) {
        throw new Error('주문 생성 실패');
      }

      const orderData = await orderResponse.json();

      // 3. 결제 처리
      if (paymentMethod === 'card') {
        const paymentResponse = await fetch(`${API_CONFIG.MAIN}/kakaopay/payment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            order_id: orderData.orderId,
            item_name: tourName,
            quantity: amount,
            total_amount: totalPrice
          })
        });

        if (!paymentResponse.ok) {
          throw new Error('결제 처리 실패');
        }

        const paymentData = await paymentResponse.json();
        window.location.href = paymentData.next_redirect_pc_url;
      } else if (paymentMethod === 'transfer') {
        alert('계좌이체를 진행하면 YourNEST 관리자가 확인 후 승인 처리합니다');
        navigate('/payment-transfer', {
          state: {
            tourName,
            reservationDate,
            reservationTime,
            amount,
            totalPrice,
            userName: getCookie('yournest_u_name')
          }
        });
      }
    } catch (error) {
      console.error('결제 처리 중 오류 발생:', error);
      alert('결제 처리 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className="studio-payment">

      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />

      <div className="payment-info-area">
        <div className="payment-info-area__title">결제 정보</div>
        <div className="payment-info-area__content">
          <div className="payment-info-area__row">
            <div className="payment-info-area__label">투어명</div>
            <div className="payment-info-area__value">{tourName}</div>
          </div>
          <div className="payment-info-area__row">
            <div className="payment-info-area__label">예약일시</div>
            <div className="payment-info-area__value">
              {reservationDate ? `${new Date(reservationDate).toLocaleDateString()} ${reservationTime}` : '-'}
            </div>
          </div>
          <div className="payment-info-area__row">
            <div className="payment-info-area__label">인원</div>
            <div className="payment-info-area__value">{amount}인</div>
          </div>
        </div>
      </div>

      <div className="payment-method-area">
        <div className="payment-method-area__title">결제 수단</div>
        <div className="payment-method-area__options">
          <div 
            className={`payment-method-area__option ${paymentMethod === 'card' ? 'active' : ''}`}
            onClick={() => setPaymentMethod('card')}>
            카카오페이
          </div>
          <div 
            className={`payment-method-area__option ${paymentMethod === 'transfer' ? 'active' : ''}`}
            onClick={() => setPaymentMethod('transfer')}>
            계좌이체
          </div>
        </div>
        <div className="payment-method-area__description">카카오페이는 테스트용으로 결제되지 않습니다.</div>
      </div>

      <div className="payment-amount-area">
        <div className="payment-amount-area__row">
          <div className="payment-amount-area__label">결제 금액</div>
          <div className="payment-amount-area__value">{totalPrice.toLocaleString()}원</div>
        </div>
      </div>

      <div className="payment-button" onClick={handlePayment}>결제하기</div>
    </div>
  );
};
